import { ItemIntegrationFragment } from 'generated/resources/graphql'

import ExternalIntegrations from './ExternalIntegrations'
import InternalIntegrations from './InternalIntegrations'

interface IntegrationSettingsProps {
  integration: ItemIntegrationFragment
}

export const IntegrationSettings = ({ integration }: IntegrationSettingsProps) => {
  return (
    <>
      {integration.installable ? (
        <InternalIntegrations integration={integration} />
      ) : (
        <ExternalIntegrations integration={integration} />
      )}
    </>
  )
}
